import { render, staticRenderFns } from "./OssVote.vue?vue&type=template&id=89c8d6a2&scoped=true"
import script from "./OssVote.vue?vue&type=script&lang=js"
export * from "./OssVote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c8d6a2",
  null
  
)

export default component.exports